var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLiked = function SvgLiked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211.572,
    height: 186.263,
    viewBox: "0 0 211.572 186.263",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart_1_",
    "data-name": "heart (1)",
    d: "M194.788,17.91A57.654,57.654,0,0,0,152.469,0a54.2,54.2,0,0,0-33.244,11.157A66.987,66.987,0,0,0,105.786,24.8,66.951,66.951,0,0,0,92.345,11.157,54.192,54.192,0,0,0,59.1,0a57.658,57.658,0,0,0-42.32,17.91C5.961,29.325,0,44.919,0,61.822c0,17.4,6.668,33.322,20.984,50.118,12.807,15.024,31.213,30.276,52.528,47.937,7.278,6.031,15.528,12.868,24.095,20.15,2.263,1.927,5.167,6.236,8.179,6.236s5.916-4.308,8.176-6.233c8.566-7.284,16.821-14.123,24.1-20.158,21.312-17.658,39.718-32.908,52.525-47.934,14.316-16.795,20.983-32.72,20.983-50.118C211.572,44.919,205.611,29.325,194.788,17.91Zm0,0",
    fill: "#002e6d"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLiked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/liked.20009ac1.svg";
export { ForwardRef as ReactComponent };